<div class="ou-collections-grid-container">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-state">
    <mat-progress-spinner
      diameter="80"
      mode="indeterminate"
      color="primary">
    </mat-progress-spinner>
    <p class="loading-text">Loading OU collections...</p>
  </div>

  <!-- Grid State -->
  <lib-cdw-search-grid
    [class.hidden]="isLoading"
    class="ag-theme-balham"
    [columnDefs]="columnDefs"
    [itemLabel]="itemLabel"
    [searchGridDataSource]="'sql'"
    (rowClicked)="onRowClicked($event)"
    [filterBarSettings]="filterBarSettings"
    [cdwSearchGridDataService]="orgUnitCollectionDataService"
    [componentId]="orgUnitCollectionsSearchComponentId"
    (deleteRowClicked)="deleteOuCollectionClicked($event)"
    (dataLoaded)="onDataLoaded()"
    [filterBySelectedColumnName]="filterBySelectedColumnName"
    [useMatIcon]="true"
    [customTextColor]="customTextColor"
    [firstColumnTextColor]="firstColumnTextColor"
    [customHeaderTextColor]="customTextColor"
    customHeaderFontWeight="700"
    customFirstColumnFontWeight="700"
    customRowFontWeight="400"
    [rowHeight]="36"
    #ouCollectionsGrid
  ></lib-cdw-search-grid>

  <!-- Show overlay when no OU collections exist -->
  <lib-cdw-empty-state-overlay
    *ngIf="showEmptyState"
    [htmlContent]="ouCollectionsEmptyStateHtml"
  ></lib-cdw-empty-state-overlay>
</div>
